'use strict'

import hljs from 'highlight.js'

window.hljs = hljs

require('highlightjs-line-numbers.js')

var vueHighlightJS = {}

vueHighlightJS.install = function install (Vue) {
  Vue.directive('highlightjs', {
    deep: true,
    bind: function bind (el, binding) {
      // on first bind, highlight all targets
      var targets = el.querySelectorAll('code')
      var target
      var i

      for (i = 0; i < targets.length; i += 1) {
        target = targets[i]

        if (typeof binding.value.code === 'string') {
          // if a value is directly assigned to the directive, use this
          // instead of the element content.
          target.textContent = binding.value.code
        }

        hljs.highlightBlock(target)
        hljs.lineNumbersBlock(target)

        if (typeof binding.value.code === 'string' || typeof binding.value.code === 'number') {
          var line = binding.value.line

          let highlightInterval = setInterval(() => {
            if (target.querySelectorAll(`td[data-line-number="${line}"]`).length === 0) {
              return
            }

            clearInterval(highlightInterval)

            for (let cell of target.querySelectorAll(`td[data-line-number="${line}"]`)) {
              cell.classList.add('hljs-ln-number--highlighted')
            }
          }, 100)
        }
      }
    },
    componentUpdated: function componentUpdated (el, binding) {
      // after an update, re-fill the content and then highlight
      var targets = el.querySelectorAll('code')
      var target
      var i

      for (i = 0; i < targets.length; i += 1) {
        target = targets[i]
        if (typeof binding.value.code === 'string') {
          target.textContent = binding.value.code
        }
        hljs.highlightBlock(target)
        hljs.lineNumbersBlock(target)

        if (typeof binding.value.code === 'string' || typeof binding.value.code === 'number') {
          var line = binding.value.line

          let highlightInterval = setInterval(() => {
            if (target.querySelectorAll(`td[data-line-number="${line}"]`).length === 0) {
              return
            }

            clearInterval(highlightInterval)

            for (let cell of target.querySelectorAll(`td[data-line-number="${line}"]`)) {
              cell.classList.add('hljs-ln-number--highlighted')
            }
          }, 100)
        }
      }
    }
  })
}

export default vueHighlightJS
